import { FavyColumns } from "./FavyColumns";
import { ThemeContext, WEB_REVIEW_WIDGET } from "./ThemeContext";

export const FavyColumnsWebWidget = (props) => (
	<ThemeContext.Provider value={{ reviewWidget: WEB_REVIEW_WIDGET, ...props }}>
		<FavyColumns {...props} />
	</ThemeContext.Provider>
);
